import { render, staticRenderFns } from "./CandidateWrapper.vue?vue&type=template&id=aad22232&scoped=true&"
import script from "./CandidateWrapper.vue?vue&type=script&lang=ts&"
export * from "./CandidateWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateWrapper.vue?vue&type=style&index=0&id=aad22232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad22232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMain } from 'vuetify/lib/components/VMain';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VMain,VMenu,VSkeletonLoader,VTextarea})
